module.exports = __webpack_public_path__ + "350e80beb4d3dd1ecff502049a4c0ef6.png";